(function (){
    'use strict';

    angular
        .module('services')
        .service('ObservationsEdufindmeService', ObservationsEdufindmeService);

    ObservationsEdufindmeService.$inject = ['$http', 'API_BASE'];

    function ObservationsEdufindmeService ($http, API_BASE) {
        var service = this;

        service.saveObservations   = saveObservations;
        service.observations       = observations;


        function saveObservations (query) {
            return $http.post(API_BASE + '/edufindme/observations/save', query);
        }

        function observations (query) {
            return $http.get(API_BASE + '/edufindme/observations/list', {'params':query});
        }


    }
})();